export const PRODUCTS_FETCH_SUCCESS = 'PRODUCTS_FETCH_SUCCESS';
export const PRODUCTS_TYPE_LIST = 'PRODUCTS_TYPE_LIST';
export const PRODUCTS_UNIT_LIST = 'PRODUCTS_UNIT_LIST';
export const PRODUCT_CODE = 'PRODUCT_CODE';
